import { defineMessages } from 'react-intl'

export default defineMessages({
  CardNoPlaceholder: {
    id: 'components.PaymentMethods.AddNewCard.CardNoPlaceholder',
    defaultMessage: 'Card Number',
    description: '请修改',
  },
  ExpireDatePlaceholder: {
    id: 'components.PaymentMethods.AddNewCard.ExpireDatePlaceholder',
    defaultMessage: 'MM/YY',
    description: '请修改',
  },
  CardholderNamePlaceholder: {
    id: 'components.PaymentMethods.AddNewCard.CardholderNamePlaceholder',
    defaultMessage: 'Cardholder Name',
    description: '请修改',
  },
  EmailPlaceholder: {
    id: 'components.PaymentMethods.AddNewCard.EmailPlaceholder',
    defaultMessage: 'Receipt Email(Optional)',
    description: '请修改',
  },
  Pay: {
    id: 'components.PaymentMethods.AddNewCard.Pay',
    defaultMessage: 'Pay',
    description: '请修改',
  },
  PCI: {
    id: 'components.PaymentMethods.AddNewCard.PCI',
    defaultMessage:
      'Industry-standard encryption has been implied to protect confidentiality of cards.',
    description: '请修改',
  },
  HaveSavedCardCheck: {
    id: 'components.PaymentMethods.AddNewCard.HaveSavedCardCheck',
    defaultMessage: 'Login to view saved Card Details',
    description: '请修改',
  },
  OrOnetimePaywithCard: {
    id: 'components.PaymentMethods.AddNewCard.OrOnetimePaywithCard',
    defaultMessage: 'Pay with new card',
    description: '请修改',
  },
  UseMyHistory: {
    id: 'components.PaymentMethods.AddNewCard.UseMyHistory',
    defaultMessage: 'Pay with saved card',
    description: '请修改',
  },
  BtnText: {
    id: 'components.PaymentMethods.AddNewCard.BtnText',
    defaultMessage: 'Proceed to pay',
    description: '请修改',
  },
  Useanewcard: {
    id: 'components.PaymentMethods.AddNewCard.Useanewcard',
    defaultMessage: 'Enter card details',
    description: '请修改',
  },
  Incasethatyouwanttoreceiveyourpaymentreceipt: {
    id: 'components.PaymentMethods.AddNewCard.Incasethatyouwanttoreceiveyourpaymentreceipt',
    defaultMessage: "In case you'd like to receive payment receipt.",
    description: '请修改',
  },
  SavedwithEmail: {
    id: 'components.PaymentMethods.AddNewCard.SavedwithEmail',
    defaultMessage: 'Saved with Mobile:',
    description: '请修改',
  },
  PayBypaymentprovidesservicetothousandsmerchants: {
    id: 'components.PaymentMethods.AddNewCard.PayBypaymentprovidesservicetothousandsmerchants',
    defaultMessage: 'PayBy payment provides service to thousands merchants.',
    description: '请修改',
  },
  Savedwithyourorderaccountid: {
    id: 'components.PaymentMethods.AddNewCard.Savedwithyourorderaccountid',
    defaultMessage: 'Saved with your order account id.',
    description: '请修改',
  },
  Savefornexttimeuse: {
    id: 'components.PaymentMethods.AddNewCard.Savefornexttimeuse',
    defaultMessage: 'Save Card',
    description: '请修改',
  },
  Bycontinuingyourpaymentyouagreetotheour:{
    id: 'components.PaymentMethods.AddNewCard.Bycontinuingyourpaymentyouagreetotheour',
    defaultMessage: 'By continuing your payment, you agree to the our {terms} and {privacy}',
    description: '请修改',
  },
  Enter_the_card_information_or_login_your_mobile_number_to_show_your_saved_card_details:{
    id: 'components.PaymentMethods.AddNewCard.enter_the_card_information_or_login_your_mobile_number_to_show_your_saved_card_details',
    defaultMessage: 'Enter the card information or login your mobile number to show your saved card details.',
    description: '请修改',
  }
})
